export interface Stats {
    tableViewed: number,
    tableInteractions: number,
    tableEdits:number,
    tableShares: number,
    tableDocumentsDownloads: number,
    tableDocumentsViewed: number,
    tablePDFRenditionsDownloaded: number,
    tableDocumentsEdited:number,
}



//Chart Layout
export const chartLabels: string[] = ["Records Downloaded", "Table Views", "Document Views", "Edits to Documents", "PDF Renditions Downloaded"];
export const chartBackground: string[] = ['rgba(20, 113, 156, 0.8)', 'rgba(15, 85, 117, 0.8)', 'rgba(29, 159, 219, 0.8)', 'rgba(227, 105, 64, 0.8)', 'rgba(242, 185, 25, 0.8)'];
export const chartBorder: string[] = ['rgba(20, 113, 156, 1)', 'rgba(15, 85, 117, 1)', 'rgba(29, 159, 219, 1)', 'rgba(227, 105, 64, 1)', 'rgba(242, 185, 25, 1)'];